import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export const fileUrl = (path) => (!path ? "" : /^(https?:|blob:|data:)/.test(path) ? path : `${API}/files/${path}`);

export const errMsg = (e) => e?.response?.data?.detail || e?.message || "Something went wrong";
